<template>
    <v-modal
            v-bind="$attrs"
            v-on="$listeners"
            :title="$t('fillForm')"
            @opened="reset"
    >
        <div class="error-message" v-if="error">
            {{ error }}
        </div>
        <order-quote-form
                :company-name="companyName"
                v-model="form"
        />
        <template slot="footer">
            <v-button
                    :content="sending ? $t('sending') : $t('sendRequest')"
                    :disabled="submitDisabled"
                    @click="handleSubmit"
            />
        </template>
    </v-modal>
</template>

<script>
    import OrderQuoteForm from './OrderQuoteForm.vue';

    const initialForm = () => ({
        name: null,
        email: null,
        phone: null,
        city: null,
        comment: null,
        agreement: null,
    });

    export default {
        name: 'OrderQuoteModal',
        $_veeValidate: {validator: 'new'},
        props: {
            onSubmit: {
                type: Function,
                required: true,
            },
            companyName: {
                type: String,
                required: true,
            },
            error: String,
        },
        data() {
            return {
                form: initialForm(),
                sending: false,
            };
        },
        methods: {
            async handleSubmit() {
                const {$validator, form} = this;

                if (!await $validator.validateAll()) {
                    return;
                }

                try {
                    this.sending = true;
                    await this.onSubmit({...form});

                } finally {
                    this.sending = false;
                }
            },
            reset() {
                this.form = initialForm();
            },
        },
        computed: {
            submitDisabled() {
                const {fields} = this;

                if (!this.fields) {
                    return true;
                }

                return Object.keys(fields).some(key => fields[key].invalid);
            },
        },
        components: {
            OrderQuoteForm,
        },
    };
</script>
